import { AsYouType, getCountryCallingCode } from "libphonenumber-js"

export const formatPhoneNumber = (code = "", value = "", countryCode) => {
  const raw = value.replace(/\D/g, "")

  if (!raw) return ""
  if (!countryCode) return raw

  try {
    const nationalFormatted = new AsYouType(countryCode).input(raw)

    if (nationalFormatted !== raw) {
      return nationalFormatted
    }

    const callingCode = getCountryCallingCode(countryCode)

    const internationalFormatted = new AsYouType().input(`+${callingCode}${raw}`)

    return internationalFormatted.replace(`+${callingCode}`, "").trim()
  } catch {
    return raw
  }
}
